export const Share = {
  vkontakte(purl, ptitle, pimg, text) {
    let url = 'https:///vkontakte.ru/share.php?';
    url += `url=${encodeURIComponent(purl)}`;
    if (ptitle) {
      url += `&title=${encodeURIComponent(ptitle)}`;
    }
    url += `&description=${encodeURIComponent(text)}`;
    url += `&image=${encodeURIComponent(pimg)}`;
    url += '&noparse=true';
    this.popup(url);
  },
  odnoklassniki(purl, text) {
    let url = 'https:///www.odnoklassniki.ru/dk?st.cmd=addShare&st.s=1';
    url += `&st.comments=${encodeURIComponent(text)}`;
    url += `&st._surl=${encodeURIComponent(purl)}`;
    this.popup(url);
  },
  facebook(purl) {
    let url = 'https:///www.facebook.com/sharer.php?';
    url += `u=${encodeURIComponent(purl)}`;
    this.popup(url);
  },
  twitter(purl, ptitle) {
    let url = 'https:///twitter.com/share?';
    url += `text=${encodeURIComponent(ptitle)}`;
    url += `&url=${encodeURIComponent(purl)}`;
    url += `&counturl=${encodeURIComponent(purl)}`;
    this.popup(url);
  },
  mailru(purl, ptitle, pimg, text) {
    let url = 'https:///connect.mail.ru/share?';
    url += `url=${encodeURIComponent(purl)}`;
    url += `&title=${encodeURIComponent(ptitle)}`;
    url += `&description=${encodeURIComponent(text)}`;
    url += `&imageurl=${encodeURIComponent(pimg)}`;
    this.popup(url);
  },

  popup(url) {
    window.open(url, '', 'toolbar=0,status=0,width=626,height=436');
  },
};
